export default __webpack_public_path__ + "static/media/1268.ecd48070.jpeg";